import _styled from "styled-components";
const _excluded = ["count", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styledC from 'styled-components';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
const StyledDiv = styledC.div.withConfig({
  displayName: "SelectedCount__StyledDiv",
  componentId: "sc-j9itpk-0"
})(["", " display:flex;align-items:center;color:", ";"], theme.typography.labelSmall, theme.tokens.colors.text.secondary.value);
var _StyledStyledDiv = styledC(StyledDiv).withConfig({
  displayName: "SelectedCount___StyledStyledDiv",
  componentId: "sc-j9itpk-1"
})(["", ""], p => p.$_css);
const SelectedCount = _ref => {
  let {
      count,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(_StyledStyledDiv, _extends({}, props, {
    $_css: style
  }), T.translate('SELECTED', {
    count
  }));
};
export default SelectedCount;
//# sourceMappingURL=SelectedCount.js.map